import apiResponse from "@/models/base/apiResponse";
import { httpClient } from "@/helpers/httpClient";
export default class routeReportApi {
    resource = "/api/application/routereports";
    async getRouteReports() {
        const response = new apiResponse(async () => await httpClient.get(this.resource));
        await response.ready;
        return response;
    }
}
